import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { selectCourseProgress } from '../../../redux/personaliseLessons/moduleProgressSlice'

const BottomStickyBar = ({ isAtEnd, handleNavigation }) => {

    const courseProgress = useSelector(selectCourseProgress)?.progress
    
    const newLearners = useCallback(() => {
        const time = new Date()
        const hours = time.getHours()
        const minutes = time.getMinutes()
        let maxLearners = hours.toString() + (minutes < 9 ? '0' + minutes.toString() : minutes.toString())
        return Math.max(parseInt(maxLearners)+9, 171)
    }, [])

    return (
        <>
           <div className={`fixed bottom-0 z-50 px-2 w-full left-0 flex justify-between md:left-1/2 md:-translate-x-[50%] text-center py-3 md:px-6  ${isAtEnd ? 'hidden' : 'bg-[#26588B]'}`}>
                <div className='flex flex-col items-start ml-2'>
                    <div className='w-[96px]'>
                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Group_7460.png?updatedAt=1685799750611" alt="" className='w-full h-'/>
                    </div>
                    <p className='text-xs mt-0.5'>{newLearners()} LearnTubeX Upgrades Today</p>
                </div>
                <div className='mt-1'>
                    <div className='bg-[#7FC241] text-sm font-semibold cursor-pointer px-3 py-2 rounded-lg btn--glow' onClick={handleNavigation}>{courseProgress === 0 ? 'Start Learning' : courseProgress === 100 ? 'Completed' : 'Continue Learning'}</div>
                </div>
            </div> 
        </>
    )
}

export default BottomStickyBar
